<template>
  <div class="transfer-cell">
    <img @click.stop="clickCell"
         class="transfer-cell__img" :src="iconEdit"/>
  </div>
</template>

<script>
import iconTransferRed from '@/assets/images/icon-transfer-red.png'
import iconTransferGreen from '@/assets/images/icon-transfer-green.png'
import _ from 'lodash'
export default {
  name: 'TransferCell',
  props: ['row', 'column', 'index'],
  data () {
    return {
      iconTransferRed: iconTransferRed,
      iconTransferGreen: iconTransferGreen
    }
  },
  computed: {
    iconEdit () {
      const hasEarned = _.get(this.row, this.column.prop, 0) > 0
      return hasEarned ? iconTransferGreen : iconTransferRed
    }
  },
  methods: {
    clickCell () {
      const action = _.get(this.column, 'action', '')
      const hasEarned = _.get(this.row, this.column.prop, 0) > 0
      if (action && typeof action === 'function' && hasEarned) action(this.row, this.column)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.transfer-cell {
  @include global-font;
  position: relative;
  display: flex;
  justify-content: center;
  width: 52px;
  min-width: 52px;
  padding-left: 9px;
  z-index: 11;
  user-select: none;

  &__img {
    border-radius: 50%;
    width: 21px;
    height: 21px;
    cursor: pointer;
    z-index: 1;

    &_center {
      margin: 0 10px;
    }

    &_first {
      order: -1;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/TransferCell/TransferCell.vue